/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCornerRightUp = createReactComponent("corner-right-up", "IconCornerRightUp", [
  ["path", { d: "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4", key: "svg-0" }]
]);

export { IconCornerRightUp as default };
//# sourceMappingURL=IconCornerRightUp.js.map
